export const STATUSES = ["Confirmed", "Completed", "Paid", "Hold", "Refunded", "Cancelled"];

export const STATUS_STYLES = {
  Confirmed: { badge: "bg-emerald-50 text-emerald-800 border-emerald-300", dot: "bg-emerald-500", item: "text-emerald-800 data-[highlighted]:bg-emerald-50" },
  Completed: { badge: "bg-teal-700 text-white border-teal-800", dot: "bg-white", item: "text-teal-800 data-[highlighted]:bg-teal-50" },
  Paid: { badge: "bg-[#0E1E38] text-white border-[#0E1E38]", dot: "bg-[#FACC15]", item: "text-[#0E1E38] data-[highlighted]:bg-sky-50" },
  Hold: { badge: "bg-amber-50 text-amber-800 border-amber-300", dot: "bg-amber-500", item: "text-amber-800 data-[highlighted]:bg-amber-50" },
  Refunded: { badge: "bg-purple-50 text-purple-800 border-purple-300", dot: "bg-purple-500", item: "text-purple-800 data-[highlighted]:bg-purple-50" },
  Cancelled: { badge: "bg-rose-50 text-rose-700 border-rose-300 line-through", dot: "bg-rose-500", item: "text-rose-700 data-[highlighted]:bg-rose-50" },
};

export const CONFIRMED_STATUSES = ["Confirmed", "Completed", "Paid"];

export const AU_STATES = ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"];

export const PRICING_TYPES = [
  { value: "hourly", label: "Hourly" },
  { value: "fixed", label: "Fixed price" },
  { value: "cubic", label: "Share Load / m³" },
];

export const DEPOSIT_METHODS = ["Card", "Stripe", "Bank Transfer", "PayID", "Cash", "Other"];

export const EXTRA_TYPES = ["Heavy Item", "Stairs", "Excessive Walking Distance", "Waiting Time", "Extra Stop",
  "Additional Items", "Wrapping", "Packing Materials", "Additional Labour", "Difficult Access", "Other"];
export const WRAPPING_TYPES = ["Wrapping", "Packing Materials"];

export const AUDIT_ACTIONS = [
  { value: "created", label: "Created" },
  { value: "updated", label: "Edited" },
  { value: "status_changed", label: "Status changed" },
  { value: "note_added", label: "Note added" },
  { value: "imported", label: "Imported" },
  { value: "deleted", label: "Deleted" },
  { value: "photo_added", label: "Photo added" },
  { value: "photo_removed", label: "Photo removed" },
];

export const BRAND = "City Removalists and Storage";
